import { AnimatedSection, SectionHeader, CardSpotlight } from '@/components/ui';

export const Features = () => {
  return (
    <section id="features" className="py-16 md:py-24">
      <AnimatedSection className="container">
        <SectionHeader
          title="Everything your support team does — automated"
          description="One platform to train, deploy, and analyze your AI chatbot."
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-12">
          {/* Tile 1 — Knowledge Base (anchor tile, spans 2 columns) */}
          <CardSpotlight className="p-6 md:p-8 md:col-span-2" radius={420}>
            <p className="font-display text-6xl font-black text-primary/20 leading-none mb-3 transition-colors duration-300 group-hover:text-primary/35">01</p>
            <h3 className="font-display text-xl font-bold text-foreground tracking-tight mb-2">
              Train your bot on real docs
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Upload PDFs, FAQs, and support guides. Your chatbot learns from your actual content — not generic answers.
            </p>
          </CardSpotlight>

          {/* Tile 2 — AI Chat */}
          <CardSpotlight className="p-6">
            <p className="font-display text-6xl font-black text-primary/20 leading-none mb-3 transition-colors duration-300 group-hover:text-primary/35">02</p>
            <h3 className="font-display text-xl font-bold text-foreground tracking-tight mb-2">
              Answer questions in real time
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Claude-powered AI reads your content and replies instantly, 24/7, in your brand voice.
            </p>
          </CardSpotlight>

          {/* Tile 3 — Embed Anywhere */}
          <CardSpotlight className="p-6">
            <p className="font-display text-6xl font-black text-primary/20 leading-none mb-3 transition-colors duration-300 group-hover:text-primary/35">03</p>
            <h3 className="font-display text-xl font-bold text-foreground tracking-tight mb-2">
              Go live with one script tag
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Copy one line of code. Works on Shopify, WordPress, Wix, or any custom site.
            </p>
          </CardSpotlight>

          {/* Tile 4 — Analytics (spans 2 columns to mirror Tile 1 layout) */}
          <CardSpotlight className="p-6 md:col-span-2" radius={420}>
            <p className="font-display text-6xl font-black text-primary/20 leading-none mb-3 transition-colors duration-300 group-hover:text-primary/35">04</p>
            <h3 className="font-display text-xl font-bold text-foreground tracking-tight mb-2">
              See exactly what visitors ask
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Track every question, spot gaps in your content, and improve over time.
            </p>
          </CardSpotlight>
        </div>
      </AnimatedSection>
    </section>
  );
};
